import ModelData from "../../../public/model_data";
import LoaclStorage from "../../../../manager/local_storage";
import ModuleManager from "../../../../framework/core/module_manager";
import MVVMBase from "../../../../framework/core/mvvm/mvvm_base";
import Utility from "../../../../utility/utility";
import TimeManager from "../../../../manager/time_manager";
import { RedPointModule } from "../../../public/component/redpoint_component";
import PromiseUtility from "../../../../utility/promiseUtility";

export class ActivityCode {
    static day_welfare: string = 'day_welfare'
    static bind_mobile: string = 'bind_mobile'
    static reg_game_user: string = 'reg_game_user'
    static bind_parent: string = 'bind_parent'
}

const { ccclass, property } = cc._decorator;
@ccclass
export default class ActivityUtil {
    protected static code_url_map = {
        [ActivityCode.day_welfare]: 'activity/daywelfare/getDayWelfareProgressV2?',
        [ActivityCode.bind_mobile]: 'activity/bindmobile/getBindMobileProgressV2?',
        [ActivityCode.bind_parent]: 'activity/bindparent/getBindParentProgress?',
    }
    protected static m_redPointData = null
    static get_hide_red_point_key(topIndex: number, data) {
        let key = ''
        if (topIndex == 0) {  //活动
            key = 'dailyActivity-' + ModelData.instance.roleData.id
        } else {  //公告
            key = 'noticy-' + ModelData.instance.roleData.id + '-' + data.businessNoticeId
        }
        return key
    }

    static cleanUnusedRedPointData(keys: string[]) {
        let data = this.m_redPointData || LoaclStorage.getJson('activity_hide_red_point_data') || {}
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                if (!keys.includes(key)) {
                    delete data[key]
                }
            }
        }
    }

    static getHideRedPointData(key) {
        let data = this.m_redPointData || LoaclStorage.getJson('activity_hide_red_point_data') || {}
        this.m_redPointData = data
        return data[key]
    }

    static setHideRedPointData(key) {
        let data = this.m_redPointData || {}
        data[key] = true
        LoaclStorage.setJson('activity_hide_red_point_data', data)
    }

    //获取公告数据
    static getNoticeData(success: Function, fail: Function, mvvmBase: MVVMBase) {
        let requestData: IHttpRequestData = {
            baseUrl: "notice/getNoticeList?",
        }
        mvvmBase.apiHttpGet(requestData, function (retData) {
            success(retData.data)
        }, (retData) => {
            fail && fail(retData)
            // ModuleManager.instance.toast500error(retData)
        })
    }

    static queryActivityList(success, fail, mvvmBase: MVVMBase) {
        let requestData: IHttpRequestData = {
            baseUrl: 'activity/queryList?',
        }
        ActivityUtil._get_http(requestData, success, fail, mvvmBase)
    }

    static getActivitysProgress(activityList: any[], success, fail, mvvmBase: MVVMBase) {
        let requestDatas: IUrlRequestAllData[] = []
        for (let index = 0; index < activityList.length; index++) {
            const data = activityList[index];
            if (data.activityCode == 'day_welfare') {
                continue
            }
            requestDatas.push({ requestData: ActivityUtil.getRequestDataByActivityCode(data.activityCode, data.activityId) })
        }
        ActivityUtil._get_http_all(requestDatas, function (allData: IUrlResponseAllData) {
            let dataList = []
            for (let index = 0; index < requestDatas.length; index++) {
                const element = requestDatas[index];
                let activity = activityList[index]
                let tmpData = allData.responseDataMap[element.requestData.baseUrl]
                if (tmpData && tmpData.successData) {
                    if (tmpData.successData.code == 'SUCCESS' && tmpData.successData.data) {
                        let resultData = tmpData.successData.data
                        resultData.activityId = activity.activityId
                        resultData.activityDesc = activity.activityDesc
                        resultData.activityCode = activity.activityCode
                        resultData.activityName = activity.activityName
                        dataList.push(tmpData.successData.data)
                    }
                }
            }
            success && success(dataList)
        }, mvvmBase)
    }

    protected static getRequestDataByActivityCode(code: string, activityId): IHttpRequestData {
        let requestData: IHttpRequestData = {
            baseUrl: ActivityUtil.code_url_map[code],
            params: {
                activityId: activityId,
            },
        }
        return requestData
    }

    static getAllAcitvityData(success, fail, mvvmBase: MVVMBase) {
        ActivityUtil.queryActivityList(function (dataList) {
            ActivityUtil.getActivitysProgress(dataList, success, fail, mvvmBase)
        }, fail, mvvmBase)
    }

    private static _get_http(requestData, success, fail, mvvmBase: MVVMBase) {
        mvvmBase.apiHttpGet(requestData, function (retData) {
            success(retData.data)
        }, (retData) => {
            fail && fail(retData)
            // ModuleManager.instance.toast500error(retData)
        })
    }

    private static _get_http_all(requestDatas: IUrlRequestAllData[], onAllFinish: (data: IUrlResponseAllData) => void, mvvmBase: MVVMBase) {
        mvvmBase.http_get_all(requestDatas, onAllFinish)
    }

    static requestDrawActivityAward(activityId, success, fail, mvvmBase: MVVMBase, disableTimeOutRequest?) {
        let requestData = {
            baseUrl: 'activity/receive?',
            params: {
                activityId: activityId,
            },
            disableTimeOutRequest: disableTimeOutRequest
        }
        ActivityUtil._get_http(requestData, success, fail, mvvmBase)
    }

    static requestDrawActivityAttachAward(activityId, success, fail, mvvmBase: MVVMBase) {
        let requestData = {
            baseUrl: 'activity/receiveAttachAward?',
            params: {
                activityId: activityId,
            }
        }
        ActivityUtil._get_http(requestData, success, fail, mvvmBase)
    }

    static getSignWeekNumActivity(success, fail, mvvmBase: MVVMBase) {
        let requestData = {
            baseUrl: 'activity/signweeknum/getSignWeekNumActivity?',
            params: {}
        }
        ActivityUtil._get_http(requestData, success, fail, mvvmBase)
    }

    static getSignWeekNumAttachProgress(activityId, success, fail, mvvmBase: MVVMBase) {
        let requestData = {
            baseUrl: 'activity/signweeknum/getSignWeekNumAttachProgress?',
            params: {
                activityId: activityId,
            }
        }
        ActivityUtil._get_http(requestData, success, fail, mvvmBase)
    }

    static getSignWeekNumProgress(activityId, success, fail, mvvmBase: MVVMBase) {
        let requestData = {
            baseUrl: 'activity/signweeknum/getSignWeekNumProgress?',
            params: {
                activityId: activityId,
            }
        }
        ActivityUtil._get_http(requestData, success, fail, mvvmBase)
    }
    static getAppScore(success, fail, mvvmBase: MVVMBase) {
        let requestData = {
            baseUrl: 'score/getGameUserScore?',
        }
        ActivityUtil._get_http(requestData, success, fail, mvvmBase)
    }
    static getAppScoreReward(starNum, success, fail, mvvmBase: MVVMBase) {
        let requestData = {
            baseUrl: 'score/addScore?',
            params: {
                appStore: cc.sys.os == cc.sys.OS_IOS ? "AppStore" : "GooglePlay",
                comment: "",
                os: cc.sys.os == cc.sys.OS_IOS ? "iOS" : "Android",
                starNum: starNum,
            }
        }
        ActivityUtil._get_http(requestData, success, fail, mvvmBase)
    }
    static getActivationReward(activationCode, success, fail, mvvmBase: MVVMBase) {
        let requestData = {
            baseUrl: 'activation/doAward?',
            params: {
                activationCode: activationCode,
            }
        }
        ActivityUtil._get_http(requestData, success, fail, mvvmBase)
    }

    static getFirstChargeActivity(success, fail, mvvmBase: MVVMBase) {
        let requestData = {
            baseUrl: 'activity/firstgoods/getFirstGoodsActivity?',
            params: {}
        }
        ActivityUtil._get_http(requestData, success, () => { }, mvvmBase)
    }

    static getFirstChargeProgress(activityId, success, fail, mvvmBase: MVVMBase) {
        let requestData = {
            baseUrl: 'activity/firstgoods/getFirstGoodsProgress?',
            params: {
                activityId: activityId,
            }
        }
        ActivityUtil._get_http(requestData, success, fail, mvvmBase)
    }

    static getAdvertActivity(success, mvvmBase: MVVMBase) {
        let requestData = {
            baseUrl: 'activity/watchReward/getWatchRewardActivity?',
            params: {}
        }
        ActivityUtil._get_http(requestData, success, () => { }, mvvmBase)
    }

    static getAdvertActivityProgress(activityId, success, fail, mvvmBase: MVVMBase) {
        let requestData = {
            baseUrl: 'activity/watchReward/getWatchRewardProgress?',
            params: {
                activityId: activityId,
            }
        }
        ActivityUtil._get_http(requestData, success, fail, mvvmBase)
    }

    static isHaveFirstCharge(onFinish: Function, mvvmBase: MVVMBase) {
        let tag = ActivityUtil.isFinishFirstCharge()
        //onFinish && onFinish(tag == 0)//默认已经完成
        mvvmBase.eventDispatch('refresh_firstCharge', tag == 0);
        ActivityUtil.getFirstChargeActivity(function (data) {
            if (data.activityId != undefined) {
                ActivityUtil.getFirstChargeProgress(data.activityId, function (progressData) {
                    let award = data.awards[data.awards.length - 1];
                    if (award) {
                        if (progressData) {
                            onFinish && onFinish(!progressData.isFinish, data, progressData);
                            ActivityUtil.setFisrtCharege(progressData.isFinish ? 1 : 0)
                        }
                    } else {
                        onFinish && onFinish(false);
                    }
                }, () => {
                    onFinish && onFinish(false);
                }, mvvmBase);
            } else {
                onFinish && onFinish(false);
            }
        }, () => {
            onFinish && onFinish(false);
        }, mvvmBase)
    }

    //是否可以领取首充奖励
    static isReceiveFirstCharge(onFinish: Function, mvvmBase: MVVMBase) {
        ActivityUtil.isHaveFirstCharge((isHave, data, progressData) => {
            let canReceive = false;
            if (isHave) {
                onFinish && onFinish(!progressData.isFinish)
            } else {
                onFinish && onFinish(canReceive);
            }
        }, mvvmBase)
    }

    static refreshModuleOpenTime(moduleName: string) {
        let time = TimeManager.instance.getServerTime()
        let timeStr = Utility.formatTime(time, 'yyyy-MM-dd');
        let saveStr = timeStr
        LoaclStorage.setString(moduleName + '_same_day_' + ModelData.instance.userToken, saveStr)
    }

    static hasOpenedToday(moduleName: string): boolean {
        let str = LoaclStorage.getString(moduleName + '_same_day_' + ModelData.instance.userToken) || null;
        if (str) {
            let time = TimeManager.instance.getServerTime()
            let timeStr = Utility.formatTime(time, 'yyyy-MM-dd');
            let saveStr = timeStr
            if (saveStr == str) {
                return true
            }
        }
        return false
    }

    static needAutoShowActivity(onFinish: (needShow: boolean, dataList: any) => void, mvvmBase: MVVMBase) {
        ActivityUtil.getNoticeData(function (dataList) {
            let needAuto = false
            let redPointCount = 0
            let checkActivity = function () {
                ActivityUtil.getAllAcitvityData(function (activityDataList) {
                    for (let index = 0; index < activityDataList.length; index++) {
                        const data = activityDataList[index];
                        if (data.isReceive) {
                            redPointCount++
                        } else {
                            let key = ActivityUtil.get_hide_red_point_key(0, data)
                            let hideRedPoint = ActivityUtil.getHideRedPointData(key)
                            !hideRedPoint && redPointCount++
                        }
                        if (!data.isFinish) {
                            needAuto = true
                        }
                        mvvmBase.eventDispatch('Event_Notify_RedPoint_Change', RedPointModule.Activity, redPointCount)
                    }
                    mvvmBase.eventDispatch('Event_Notify_RedPoint_Refresh')
                    onFinish(needAuto, dataList)
                }, function () {
                    onFinish(false, null)
                }, mvvmBase)
            }

            if (dataList && dataList.length > 0) {
                for (let index = 0; index < dataList.length; index++) {
                    const element = dataList[index];
                    let key = ActivityUtil.get_hide_red_point_key(1, element)
                    let hideRedPoint = ActivityUtil.getHideRedPointData(key)
                    if (element.isAutoShow) {
                        if (!hideRedPoint) {
                            needAuto = true
                        }
                    }
                    if (!hideRedPoint) {
                        redPointCount++
                    }
                }
                if (needAuto) {
                    mvvmBase.eventDispatch('Event_Notify_RedPoint_Change', RedPointModule.Activity, redPointCount)
                    mvvmBase.eventDispatch('Event_Notify_RedPoint_Refresh')
                    onFinish(true, dataList)
                } else {
                    checkActivity()
                }
            } else {
                checkActivity()
            }
        }, function () {
            onFinish(false, null)
        }, mvvmBase)
    }

    static getDailySignData(onFinish: (data: any) => void, mvvmBase: MVVMBase) {
        ActivityUtil.getSignWeekNumActivity(function (data) {
            if (!data || !data.activityId) {
                onFinish && onFinish(null)
                return
            }
            let activityId = data.activityId
            let dataMap: any = {}

            let dailyDataMap: any = {}
            let dailyDataList = []
            dailyDataMap.dailyDataList = dailyDataList
            dataMap.dailyDataMap = dailyDataMap

            let attachDataMap: any = {}
            let attachDataList = []
            attachDataMap.attachDataList = attachDataList
            dataMap.attachDataMap = attachDataMap

            let awardMap = {}
            for (const key in data.masterAwards) {
                if (data.masterAwards.hasOwnProperty(key)) {
                    const element = data.masterAwards[key];
                    let group = element.activityConditionGroup
                    awardMap[group] = awardMap[group] || []
                    awardMap[group].push(element)
                }
            }

            let attachAwardMap = {}
            for (const key in data.attachAwards) {
                if (data.attachAwards.hasOwnProperty(key)) {
                    const element = data.attachAwards[key];
                    let group = element.activityConditionGroup
                    attachAwardMap[group] = attachAwardMap[group] || []
                    attachAwardMap[group].push(element)
                }
            }

            for (let index = 0; index < 7; index++) {
                let dailyData: any = {}
                dailyData.dayIndex = index + 1
                dailyData.activityId = activityId
                dailyData.awardList = awardMap[dailyData.dayIndex.toString()]
                if (!dailyData.awardList) {
                    cc.error(`第${dailyData.dayIndex}次没有配置奖励`)
                }
                dailyDataList.push(dailyData)

                let attachData: any = {}
                attachData.dayIndex = index + 1
                attachData.activityId = activityId
                attachData.awardList = attachAwardMap[dailyData.dayIndex.toString()]
                attachDataList.push(attachData)
            }

            let getCommonProgress = function (cb) {
                ActivityUtil.getSignWeekNumProgress(activityId, function (data) {
                    for (let index = 0; index < dailyDataMap.dailyDataList.length; index++) {
                        const dailyData = dailyDataMap.dailyDataList[index];
                        if (index + 1 < data.currentConditionGroup) {
                            dailyData.isFinish = true
                            dailyData.isReceive = true
                        } else if (index + 1 == data.currentConditionGroup) {
                            dailyData.isFinish = data.isFinish
                            dailyData.isReceive = data.isReceive
                        } else {
                            dailyData.isReceive = false
                            dailyData.isFinish = false
                        }
                    }
                    dailyDataMap.currentConditionGroup = data.currentConditionGroup
                    dailyDataMap.isReceive = data.isReceive
                    dailyDataMap.isFinish = data.isFinish
                    cb()
                }, function () {

                }, mvvmBase)
            }

            let getAttachProgress = function (cb) {
                ActivityUtil.getSignWeekNumAttachProgress(activityId, function (data) {
                    for (let index = 0; index < attachDataMap.attachDataList.length; index++) {
                        const attachData = attachDataMap.attachDataList[index];
                        if (index + 1 < data.currentConditionGroup) {
                            attachData.isFinish = true
                            attachData.isReceive = true
                        } else if (index + 1 == data.currentConditionGroup) {
                            attachData.isFinish = data.isAttachFinish
                            attachData.isReceive = data.isAttachReceive
                            if (!attachData.awardList) {
                                cc.error(`第${attachData.dayIndex}次没有配置附属奖励`)
                            }
                        } else {
                            attachData.isReceive = false
                            attachData.isFinish = false
                        }
                        attachData.currentConditionGroup = data.currentConditionGroup
                    }
                    attachDataMap.isReceive = data.isAttachReceive
                    attachDataMap.currentConditionGroup = data.currentConditionGroup
                    attachDataMap.isFinish = data.isAttachFinish
                    cb()
                }, function () {

                }, mvvmBase)
            }

            PromiseUtility.all([getCommonProgress, getAttachProgress]).then(function () {
                let totalSignCount = 0
                if (dailyDataMap.isFinish) {
                    totalSignCount = dailyDataMap.currentConditionGroup
                } else {
                    totalSignCount = dailyDataMap.currentConditionGroup - 1
                }
                for (const key in attachDataList) {
                    if (attachDataList.hasOwnProperty(key)) {
                        const attachData = attachDataList[key];
                        attachData.totalSignCount = totalSignCount
                    }
                }
                onFinish && onFinish(dataMap)
            })
        }, function () {
            onFinish && onFinish(null)
        }, mvvmBase)
    }

    static getQuickBuyList(success, fail, mvvmBase: MVVMBase) {
        let requestData = {
            baseUrl: 'activity/quickbuy/getQuickBuyList?',
        }
        ActivityUtil._get_http(requestData, success, fail, mvvmBase)
    }

    static isHaveQuickBuy(onFinish:Function,mvvmBase: MVVMBase){
        ActivityUtil.getQuickBuyList((data:any)=>{
            onFinish&&onFinish(data && data.length > 0)
        },()=>{
            onFinish&&onFinish(false)
        },mvvmBase)
    }

    //tag:1 已经完成 0 没有完成
    static setFisrtCharege(tag: number) {
        LoaclStorage.setNumber('_isHaveFirstCharge_' + ModelData.instance.roleData.id, tag)
    }

    static isFinishFirstCharge(): number {
        return LoaclStorage.getNumber('_isHaveFirstCharge_' + ModelData.instance.roleData.id, 1);
    }
}